/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component, Fragment } from "react";
import AdvisorContext from "../context/context";
import ReactTable from "react-table";
import moment from "moment";
import enumHelper from "../../support/logic/enumHelper";
import { eventType } from "../enums.js";
import EditIcon from '@mui/icons-material/Edit';
import { getAdminLog, getUsersLog, searchUsersLog, getAdvisorEvent } from "../api"
import Link from "@material-ui/core/Link";
import LoadingIndicator from "../../common/loadingIndicator";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Multiselect from 'multiselect-react-dropdown';
import { Radio, RadioGroup, FormControlLabel } from '@mui/material';
import SimpleDialog from "../../common/simpleDialog";
import { Grid, Checkbox, Typography, IconButton, TextField, Button } from '@material-ui/core';
import Reporting from "../../common/reporting";
import LogEntry from "../entry";



const preSelectedReportFields = ["title", "description", "totalAvailableCreditHours", "startTime", "endTime", "userName"];
const skippedFields = ["advisor.deletionTime", "advisor.deleterUserId", "advisor.isDeleted", "school.district", "studentProfile.collegeId", "studentProfile.alien", "studentProfile.sasId", "studentProfile.ssn", "studentProfile.userProfileId", "userProfile.scholarshipCrusaders", "userProfile.workPhone", "userProfile.homePhone", "userProfile.emergencyContacts", "userProfile.isDeleted", "userProfile.deleterUserId", "userProfile.deletionTime", "userProfile.lastModificationTime", "userProfile.lastModifierUserId", "userProfile.creationTime", "userProfile.creatorUserId", "userProfile.domainEvents", "userProfile.id", "userProfile.userId", "userProfile.user", "userProfile.userType", "userProfile.cityId", "userProfile.bestTimeCallStart", "userProfile.primaryPhone", "userProfile.bestTimeCallEnd", "userProfile.highestLevelEducation", "userProfile.highestLevelEducationGrade", "userProfile.highestLevelEducationInUS", "userProfile.secondarySendCopy", "userProfile.schoolId", "userProfile.grade", "studentProfile.selectedInstitutionId", "studentProfile.selectedInstitutionModifiedDate", "studentProfile.otherInstitution", "studentProfile.isDeleted", "studentProfile.deleterUserId", "studentProfile.deletionTime", "studentProfile.lastModificationTime", "studentProfile.lastModifierUserId", "studentProfile.creationTime", "studentProfile.creatorUserId", "studentProfile.domainEvents", "studentProfile.id", "school.districtId", "school.userSettingSchools", "school.isActive", "school.domainEvents", "school.id", "advisor.userId", "advisor.user", "advisor.userType", "advisor.middleName", "advisor.address1", "advisor.address2", "advisor.city", "advisor.cityId", "advisor.state", "advisor.zipCode", "advisor.homePhone", "advisor.primaryPhone", "advisor.primaryLocale", "advisor.highestLevelEducation", "advisor.highestLevelEducationGrade", "advisor.highestLevelEducationInUS", "advisor.secondarySendCopy", "advisor.dateOfBirth", "advisor.schoolId", "advisor.citizenshipType", "advisor.hispanic", "advisor.race", "advisor.otherRace", "advisor.freeOrReducedLunch", "advisor.firstGeneration", "advisor.grade", "advisor.allergies", "advisor.medications", "advisor.medicalConditions", "advisor.dietaryRestrictions", "advisor.specialAccommodations", "advisor.scholarshipCrusaders", "advisor.emergencyContacts", "advisor.workPhone", "advisor.lastModificationTime", "advisor.lastModifierUserId", "family.primaryParent.grade", "family.primaryParent.firstGeneration", "family.primaryParent.freeOrReducedLunch", "family.primaryParent.race", "family.primaryParent.otherRace", "family.primaryParent.hispanic", "family.primaryParent.userId", "family.primaryParent.citizenshipType", "family.primaryParent.schoolId", "family.primaryParent.dob", "family.primaryParent.user", "family.primaryParent.userType", "family.primaryParent.cityId", "family.primaryParent.secondarySendCopy", "family.primaryParent.scholarshipCrusaders", "family.primaryParent.emergencyContacts", "family.primaryParent.isDeleted", "family.primaryParent.deleterUserId", "family.primaryParent.deletionTime", "family.primaryParent.lastModificationTime", "family.primaryParent.lastModifierUserId", "family.primaryParent.creationTime", "family.primaryParent.creatorUserId", "family.primaryParent.domainEvents", "family.primaryParent.id", "family.secondaryParent.grade", "family.secondaryParent.firstGeneration", "family.secondaryParent.freeOrReducedLunch", "family.secondaryParent.race", "family.secondaryParent.otherRace", "family.secondaryParent.hispanic", "family.secondaryParent.userId", "family.secondaryParent.citizenshipType", "family.secondaryParent.schoolId", "family.secondaryParent.dob", "family.secondaryParent.user", "family.secondaryParent.userType", "family.secondaryParent.cityId", "family.secondaryParent.secondarySendCopy", "family.secondaryParent.scholarshipCrusaders", "family.secondaryParent.emergencyContacts", "family.secondaryParent.isDeleted", "family.secondaryParent.deleterUserId", "family.secondaryParent.deletionTime", "family.secondaryParent.lastModificationTime", "family.secondaryParent.lastModifierUserId", "family.secondaryParent.creationTime", "family.secondaryParent.creatorUserId", "family.secondaryParent.domainEvents", "family.secondaryParent.id", "family.studentUserProfileId", "family.secondaryParent.highestLevelEducation", "family.secondaryParent.highestLevelEducationGrade", "family.secondaryParent.highestLevelEducationInUS", "family.secondaryParent.dateOfBirth", "family.primaryParent.dateOfBirth"];


const activityTypes = enumHelper.getSelectOptionsList(eventType)

function containsAll(arr, target) {
    return target.every(element => arr.includes(element));
}
function calculateAgeInMonths(dateString) {
    const contDate = new Date(dateString);
    const currentDate = new Date();

    let ageInMonths = (currentDate.getFullYear() - contDate.getFullYear()) * 12;
    ageInMonths -= contDate.getMonth();
    ageInMonths += currentDate.getMonth();


    if (currentDate.getDate() < contDate.getDate()) {
        ageInMonths--;
    }

    return ageInMonths;
}
// Function to get the date 30 days before now
function getDate30DaysAgo() {
    const now = new Date();
    now.setDate(now.getDate() - 30);
    now.setHours(0, 0, 1, 0); // Set time to 1 second past midnight
    return now;
}

function getDate60DaysAgo() {
    const now = new Date();
    now.setDate(now.getDate() - 60);
    now.setHours(0, 0, 1, 0); // Set time to 1 second past midnight
    return now;
}

function getDate90DaysAgo() {
    const now = new Date();
    now.setDate(now.getDate() - 90);
    now.setHours(0, 0, 1, 0); // Set time to 1 second past midnight
    return now;
}

function getDate1DayAgo() {
    const now = new Date();
    now.setDate(now.getDate() - 1);
    now.setHours(0, 0, 1, 0); // Set time to 1 second past midnight
    return now;
}

function getDate3DaysAgo() {
    const now = new Date();
    now.setDate(now.getDate() - 3);
    now.setHours(0, 0, 1, 0); // Set time to 1 second past midnight
    return now;
}

function getDate5DaysAgo() {
    const now = new Date();
    now.setDate(now.getDate() - 5);
    now.setHours(0, 0, 1, 0); // Set time to 1 second past midnight
    return now;
}


function generateRecentDates() {

    const dateRanges = [];
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() +1);
    const formattedDate = [

        String(currentDate.getMonth() + 1).padStart(2, '0'),
        String(currentDate.getDate()).padStart(2, '0'),
        currentDate.getFullYear(),
    ].join('/');

    const date30 = getDate30DaysAgo();
    const date60 = getDate60DaysAgo();
    const date90 = getDate90DaysAgo();
    const fmDt = formattedDate;
    dateRanges.push({
        label: ` Last 30 Days`,
        beginDate: date30,
        endDate: fmDt
    });
    dateRanges.push({
        label: ` Last 60 Days`,
        beginDate: date60,
        endDate: fmDt
    });
    dateRanges.push({
        label: ` Last 90 Days`,
        beginDate: date90,
        endDate: fmDt
    });

    return dateRanges;
}
function generateRecentHours() {

    const dateRanges = [];
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 1);
    const formattedDate = [

        String(currentDate.getMonth() + 1).padStart(2, '0'),
        String(currentDate.getDate()).padStart(2, '0'),
        currentDate.getFullYear(),
    ].join('/');

    const date1 = getDate1DayAgo();
    const date3 = getDate3DaysAgo();
    const date5 = getDate5DaysAgo();
    const fmDt = formattedDate;
    dateRanges.push({
        label: ` Last 24 Hours`,
        beginDate: date1,
        endDate: fmDt
    });
    dateRanges.push({
        label: ` Last 72 Hours`,
        beginDate: date3,
        endDate: fmDt
    });
    dateRanges.push({
        label: ` Last 120 Hours`,
        beginDate: date5,
        endDate: fmDt
    });

    return dateRanges;
}
function generateOlderDates() {
    const dateRanges = [];
    const OldDate = new Date('2000-01-01');

    const formattedDate = [
        String(OldDate.getMonth() + 1).padStart(2, '0'),
        String(OldDate.getDate()).padStart(2, '0'),
        OldDate.getFullYear(),
    ].join('/');

    const setToEndTime = (date) => {
        date.setHours(23, 59, 59);
        return date;
    };

    // Function to subtract one day
    const subtractOneDay = (date) => {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() - 1);
        return newDate;
    };

    const date30 = subtractOneDay(setToEndTime(getDate30DaysAgo()));
    const date60 = subtractOneDay(setToEndTime(getDate60DaysAgo()));
    const date90 = subtractOneDay(setToEndTime(getDate90DaysAgo()));

    dateRanges.push({
        label: `More Than 30 Days`,
        beginDate: formattedDate,
        endDate: date30
    });
    dateRanges.push({
        label: `More Than 60 Days`,
        beginDate: formattedDate,
        endDate: date60
    });
    dateRanges.push({
        label: `More Than 90 Days`,
        beginDate: formattedDate,
        endDate: date90
    });

    return dateRanges;
}



function generateSchoolYears() {
    const currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    // If the current date is before September 1st, subtract one year
    if (currentDate < new Date(currentYear, 8, 1)) { // Months are 0-indexed
        currentYear--;
    }

    const dateRanges = [];
    for (let i = 0; i < 3; i++) {
        const beginDate = new Date(currentYear - i, 8, 1); // September 1st
        const endDate = new Date(currentYear - i + 1, 7, 31); // August 31st


        const formattedBeginDate = [

            String(beginDate.getMonth() + 1).padStart(2, '0'),
            String(beginDate.getDate()).padStart(2, '0'),
            beginDate.getFullYear(),
        ].join('/');

        const formattedEndDate = [

            String(endDate.getMonth() + 1).padStart(2, '0'),
            String(endDate.getDate()).padStart(2, '0'),
            endDate.getFullYear(),
        ].join('/');

        const label = `${currentYear - i} - ${currentYear - i + 1}`;

        dateRanges.push({
            label,
            beginDate: formattedBeginDate,
            endDate: formattedEndDate
        });
    }

    return dateRanges;
}



function getDateColor(dateString) {
    if (dateString == null || dateString == '') {
        return '';
    }
    const age = calculateAgeInMonths(dateString);

    switch (age) {
        case 0:
            return 'black';
            break;
        case 1:
            return 'gold';
            break;
        case 2:
            return 'darkorange';
            break;
        case 3:
            return 'red';
            break;
        default:
            return 'red';
            break;

    }

}

class AdminLog extends Component {
    static contextType = AdvisorContext;

    constructor(props) {
        super(props);

        this.state = {
            
            logs: [],
            selectedDateRange: "",
            datesList: [],
            loaded: false,
            showEntry: false,
            activeEntry: false,
            entryType: "",
            title: "",
            searchText: "",
            searchTags: [],
            selectedTags: [],
            tags: [],
            stList: [],
            skipCount: 0,      
            pageSize: 200,     
            hasMore: true,     
            loadingMore: false 

        };
    }



    componentDidMount = async () => {
        let dates = [];
        dates.push(...generateRecentHours());
        dates.push(...generateRecentDates());
        dates.push(...generateOlderDates());
        dates.push(...generateSchoolYears());

        const input = generateRecentHours()[0];
        const tags = [];
        const classifications = this.context.taggingOptions;
        classifications.forEach((option) => {
            tags.push(...option.dropList);
        });



        if (this.props.match) {
            let nA = [];

            const tmp = this.context.myCases.filter(flt =>
                Array.isArray(flt.allAdvisors) &&
                flt.allAdvisors.some(advisor => advisor.userId == this.props.match.params.id)
            );

            tmp.forEach(cf => {
                if (nA.indexOf(cf) === -1) {
                    nA.push(cf);
                }
            });

            const stList = nA.map(item => ({
                userProfileId: item.userProfile.id
            }));

          
            let data = await searchUsersLog(
                stList,
                input,
                this.state.searchText,
                this.state.searchTags,
                0,
                this.state.pageSize
            );

            const results = data.data.result || [];

            this.setState({
                logs: results,
                loaded: true,
                selectedDateRange: input.label,
                datesList: dates,
                tags: tags,
                stList: stList,
                skipCount: results.length,
                hasMore: results.length > 0
            });
        } else {
            
            let data = await searchUsersLog(
                this.context.studentList,
                input,
                this.state.searchText,
                this.state.searchTags,
                0,
                this.state.pageSize
            );

            const results = data.data.result || [];

            this.setState({
                logs: results,
                loaded: true,
                selectedDateRange: input.label,
                datesList: dates,
                tags: tags,
                skipCount: results.length,
                hasMore: results.length > 0
            });
        }
    };
    toggleDates = (yr) => {


        const newSelectedDates = [...this.state.selectedDates];
        const existingIndex = newSelectedDates.findIndex(dateRange =>
            dateRange.label === yr.label
        );

        if (existingIndex > -1) {
            // It's already selected, so remove it
            newSelectedDates.splice(existingIndex, 1);
        } else {
            // It's not selected, so add it
            newSelectedDates.push(yr);
        }

        this.setState({ selectedDates: newSelectedDates });




    };

    componentDidUpdate(prevProps, prevState) {



    }
    toggleTag = (list, newRec) => {


        const newTag = this.state.tags.filter(flt => flt.id == newRec.id)

        let searchTags = [];
        const isTagPresent = this.state.selectedTags.includes(newTag[0]);

        
        const updatedTags = isTagPresent
            ? this.state.selectedTags.filter(recipient => recipient !== newTag[0])
            : [...this.state.selectedTags, newTag[0]];
        //console.log(updatedTags);
        updatedTags.forEach(tg => {

            if (tg.id.includes("|")) {
                const [tagsId, subtagId] = tg.id.split("|");
                searchTags.push({ tagsId, subtagId });
            } else {
                searchTags.push({ tagsId: tg.id, subtagId: "" });
            }

        })
        //console.log(searchTags);
        this.setState({ selectedTags: updatedTags, searchTags: searchTags });



        //console.log(this.state);

    }
    open = async (entry) => {
        let entryType = ""
        if (entry.type == 4) {
            entryType = "note";
        //    this.props.openNote(entry);
        } else {
            entryType = "log";
         //   this.props.openEntry(entry);
        }
        const ent = await getAdvisorEvent(entry.advisorEventId);

        this.setState({ activeEntry: ent.data.result, entryType: entryType, showEntry: true, title: enumHelper.getDisplayName(eventType, entry.type) })

    }
    close = () => {
        this.setState({
            activeEntry: [], entryType: "", showEntry: false, title: "" })

    }
    customDaterangeOptionRenderer = (val) => {

        //console.log(val);
        const beginDate = new Date(val.beginDate);
        beginDate.setHours(0, 0, 0, 0);


        const endDate = new Date(val.endDate);
        endDate.setHours(23, 59, 59, 999);
        const cutoff = new Date('1/2/2000');
        const isBeginDate2000 = beginDate < cutoff;


       
        const isSelected = this.state.selectedDates.some(dateRange =>
            dateRange.label === val.label
        );




        return (
            <div className="dateFilterSelection">
                <Checkbox
                    onChange={() => this.toggleDates(val)}
                    checked={isSelected}
                />   {val.label} 
            </div>
        );
    };

    loadMore = async () => {
        // Don�t double-fire or call when we know there�s nothing left
        if ( this.state.loadingMore) {
            return;
        }

        this.setState({ loadingMore: true, hasMore: false });

        try {
            // same student list logic you use elsewhere
            let studs = [];
            if (this.state.stList.length > 0) {
                studs = this.state.stList;
            } else {
                studs = this.context.studentList;
            }

            // current date range
            const input =
                this.state.datesList.find(d => d.label === this.state.selectedDateRange) ||
                this.state.datesList[0];

            const data = await searchUsersLog(
                studs,
                input,
                this.state.searchText,
                this.state.searchTags,
                this.state.skipCount,   // skip what we already have
                this.state.pageSize     // take next page
            );

            const newResults = data.data.result || [];

            this.setState(prevState => ({
                logs: [...prevState.logs, ...newResults],
                skipCount: prevState.skipCount + newResults.length,
                hasMore: newResults.length > 0,
                loadingMore: false
            }));
        } catch (e) {
            console.error(e);
            this.setState({ loadingMore: false, hasMore: false });
        }
    };
    customSpecDaterangeOptionRenderer = (val) => {



        //console.log(val);

        const beginDate = new Date(val.beginDate);
        beginDate.setHours(0, 0, 0, 0);


        const endDate = new Date(val.endDate);
        endDate.setHours(23, 59, 59, 999);


       

        const isSelected = this.state.selectedDates.some(dateRange =>
            dateRange.label === val.label
        );

        const handleRemoveClick = (e, val) => {
            e.stopPropagation(); // This stops the event from bubbling up to the parent li
            this.onCustomDateRangeRemove(val);
        };

        return (
            <div className="dateFilterSelection">
                <Checkbox
                    onChange={() => this.toggleDates(val)}
                    checked={isSelected}
                />   {val.label} 
                <RemoveCircleOutlineIcon onClick={(e) => handleRemoveClick(e, val)} className="removeIcon" />
            </div>
        );
    };

    updateSearch = async (event) => {



        this.setState({ searchText: event.target.value });


    }
    runSearch = async () => {

        this.setState({ loaded: false });
        let studs = []
        if (this.state.stList.length > 0) {
            studs = this.state.stList;
        } else {
            studs = this.context.studentList;
        }

        const input = this.state.datesList.filter(flt => flt.label == this.state.selectedDateRange)[0];

        var data = await searchUsersLog(studs, input, this.state.searchText, this.state.searchTags);

        this.setState({ logs: data.data.result, loaded: true, hasMore: data.data.result.length > 0 });




    }
    onDateRangeSelect = (selectedItem) => {
        if (selectedItem.label) {
            this.setState(prevState => ({
                selectedDates: [...prevState.selectedDates, selectedItem]
            }));
        }
    };

    onDateRangeRemove = (removedItem) => {
        this.setState(prevState => ({
            selectedDates: prevState.selectedDates.filter(item => item.label !== removedItem.label)
        }));
    };

    onCustomDateRangeSelect = (selectedItem) => {
        if (selectedItem.label) {
            this.setState(prevState => ({
                selectedDates: [...prevState.selectedDates, selectedItem],
                datesList: [...prevState.datesList, selectedItem]
            }));
        } else {
            this.setState(prevState => ({
                datesList: [...prevState.datesList, selectedItem],
                selectedDates: [...prevState.selectedDates, selectedItem]
            }));
        }
    };

    onCustomDateRangeRemove = (removedItem) => {
        this.setState(prevState => ({
            datesList: prevState.datesList.filter(item => item.label !== removedItem.label),
            selectedDates: prevState.selectedDates.filter(item => item.label !== removedItem.label)
        }));
    };

    getTitle = () => {
        const name = enumHelper.getDisplayName(eventType, this.state.activeEntry.type);
        return name;
    }

    handleChange = async (event) => {
        this.setState({ loaded: false });
        const lookup = event.target.value;

        const input = this.state.datesList.filter(flt => flt.label == lookup)[0];
        let studs = [];
        if (this.state.stList.length > 0) {
            studs = this.state.stList;
        } else {
            studs = this.context.studentList;
        }

        var data = await searchUsersLog(studs, input, this.state.searchText, this.state.searchTags);

        this.setState({ logs: data.data.result, loaded: true, selectedDateRange: event.target.value, hasMore: data.data.result.length > 0 });
    };

    render() {

        if (!this.context.myBasics.isAdmin && !this.context.myBasics.isSupervisor) {
            
            this.props.gotoLocation("dashboard");

        }

        //console.log(this.state);
        let columns = [

            {
                Header: "",
                accessor: "advisorEventId",
                width: 50,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} ><EditIcon onClick={() => this.open(row.original)} /></div>
                ),

            },
            {
                Header: "User",
                accessor: "userName",
                width: 300,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} >{row.original.userName}</div>
                ),

            }, {
                Header: "Title",
                accessor: "title",
                width: 100,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} >{row.original.title}</div>
                ),

            },
            {
                Header: "Description",
                accessor: "description",
                width: 300,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} >{row.original.description}</div>
                ),

            },
            {
                Header: "Credit Hours",
                accessor: "totalAvailableCreditHours",
                width: 100,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} >{row.original.totalAvailableCreditHours}</div>
                ),

            },
            {
                Header: "Start Date/Time",
                accessor: "startTime",
                width: 100,
                Cell: (row) => {
                    const lCont = row.value !== null ? moment(row.value).format("M/D/YY h:mm a") : "";
                    return <div className="dataCell" style={{ textAlign: "center" }}>{lCont}</div>;
                },

            }
            ,
            {
                Header: "End Date/Time",
                accessor: "endTime",
                width: 100,
                Cell: (row) => {
                    const lCont = row.value !== null ? moment(row.value).format("M/D/YY h:mm a") : "";
                    return <div className="dataCell" style={{ textAlign: "center" }}>{lCont}</div>;
                },

            }
            ,
            {
                Header: "Activity Type",
                accessor: "type",
                width: 100,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} >{enumHelper.getDisplayName(eventType, row.original.type)}</div>
                ),

            },
            {
                Header: "Created By",
                accessor: "creator",
                width: 300,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} >{row.original.creator}</div>
                ),

            }


        ];
        if (!this.state.loaded) {

            return <LoadingIndicator loading />;
        }

        return <><Grid container spacing={2}>
                <Grid item xs={12} sm={2}>
            <Link
                className={"dashboardLink"} onClick={this.props.goBack}
            >
                &lt; Back
            </Link> 
            </Grid>
            
            <Grid item xs={12} sm={6}>
                <Typography variant="h6">
                    Dates
                </Typography>
                <Grid container spacing={2 }>
                <RadioGroup value={this.state.selectedDateRange} onChange={this.handleChange} fullWidth style={{ flexDirection: 'row' }}>
                        {this.state.datesList.map((date, index) => (
                            <Grid item xs={12} sm = {4}>
                        <FormControlLabel
                            key={`${index}`}
                            value={date.label}
                            control={<Radio />}
                            label={date.label}
                                /></Grid>
                    ))}
                    
                </RadioGroup>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={4}>
                <Typography variant="h6">
                    Search
                </Typography>

                <Multiselect
                    options={this.state.tags}
                    showCheckbox={true}
                    onSelect={this.toggleTag}
                    onRemove={this.toggleTag}
                    selectedValues={this.state.selectedTags}
                    displayValue="label"
                    className="AdvisorLogsStudents"
                    avoidHighlightFirstOption={true}
                    showArrow={false}
                    name="recipientSel"
                    placeholder="Select Tags"

                />
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Enter term to search for"
                    name="title"
                    onBlur={this.updateSearch}
                    onChange={this.updateSearch}
                    value={this.state.searchText }
                />
                <Button onClick={this.runSearch} className="fieldSelectorButton">Search</Button><br/>
                <Reporting data={this.state.logs}
                    preSelected={preSelectedReportFields}
                    label="Export" doNotExport={skippedFields} className="headerActionButton" /> &nbsp; &nbsp; &nbsp;
                <Button
                    onClick={this.loadMore}
                    disabled={!this.state.hasMore}
                    className="fieldSelectorButton"
                >
                    {this.state.loadingMore ? "Loading..." : "Load More"}
                </Button>
            </Grid>
            <Grid item xs={12} sm={12}>
            <ReactTable
                data={this.state.logs}
                minRows={0}
                columns={columns}
                defaultPageSize={50}
                className="-striped -highlight tableWrapper"
                />
                

                </Grid>
        </Grid>
            <SimpleDialog open={this.state.showEntry} onClose={this.close} title={this.state.title } >
                
                <LogEntry
                    onClose={this.close}
                    activeProfile={[]}
                    activeEntry={this.state.activeEntry}
                    gotoLocation={this.props.gotoLocation}
                    mode={"Edit"}
                    match={this.state.activeEntry.id}
                    type="log"
                    entType={this.state.activeEntry.type}
                />
            </SimpleDialog>

          </>  ;
    }
}

export default AdminLog;